import {useState, useEffect} from "react";
import Table from "@mui/material/Table";
import { Paper, TableContainer, IconButton, Typography, Select, MenuItem } from "@mui/material";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";
import { EditableRow } from "./EditableRow";

export function ResourceDisplayTable({ data, columns,refresh, setRefresh, editValues, setEditValues, setModifyExisting}) {
  const [isActive, setIsActive] = useState(false);
  const [constraintChecked, setConstraintChecked] = useState(false)

  
  useEffect(() => 
    {
      data.forEach((dataVal) =>
      {
        if (dataVal.hours_worked >= .75 * dataVal.hours_max)
          dataVal.overConstraint = true
      })
      setConstraintChecked(true)
    }, [data])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
    selectedFlatRows,
    pageOptions,
    state,
    prepareRow,
  } = useTable(
    {
      columns,
      data, 
      initialState: {
        pageSize: 5,
        hiddenColumns: ["id", "name", "project_id", "worker_id", "modified_time", "created_time", "created_by", "modified_by"],
      },
    },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const { pageIndex, pageSize } = state;

  return (
    <div className="display-container">
        <Typography align='center' variant="h4" component="div" gutterBottom>
            Constraints
          </Typography>
        
      {constraintChecked ? <TableContainer key = {"Table"} sx={{marginTop: 1}} component={Paper}>
        <Table {...getTableProps()}>
          <TableHead>
            {headerGroups.map((headerGroup, i) => (
              <TableRow key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <TableCell align="center"
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    {column.render("Header")}
                    
  
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
          <TableBody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <TableRow {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <>
                        {row.isExpanded ? (
                          <EditableRow
                            cell={cell}
                            isActive={isActive}
                            setIsActive={setIsActive}
                            selectedRow={selectedFlatRows}
                            editValues={editValues}
                            setEditValues={setEditValues}
                            refresh={refresh}
                            setRefresh={setRefresh}
                            setModifyExisting = {setModifyExisting}
                          ></EditableRow>
                        ) : (
                          <TableCell align ={'center'} {...cell.getCellProps()}>
                            {cell.column.id === "edit" ? (<>
                              <IconButton
                                {...cell.row.getToggleRowExpandedProps()}
                                onClick={() => {
                                  if (!isActive) {
                                    setIsActive(true);
                                    cell.row.toggleRowExpanded();
                                    cell.row.toggleRowSelected();
                                  } else {
                                  }
                                }}
                              >
                                <EditIcon sx={{ fontSize: 20, margin: "2%" }} />
                              </IconButton>
                              </>
                            ) : (data[i].overConstraint ? 
                              <Typography color = "red">{cell.render("Cell")}</Typography> :
                              <Typography>{cell.render("Cell")}</Typography>
                            )}
                          </TableCell>
                        )}
                      </>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <div className="pagination">
          <span className="page-selector">
            <Typography sx={{fontSize: '0.875rem'}}>Rows Per Page:</Typography>
            <Select
            sx={{marginRight: '24px', marginLeft: '8px', fontSize: '0.875rem'}}
              disableUnderline
              variant="standard"
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            >
              {[10, 15, 25, 50].map((pageSize) => (
                <MenuItem key={pageSize} value={pageSize}>
                  {pageSize}
                </MenuItem>
              ))}
            </Select>
            <Typography sx={{fontSize: '0.875rem', marginRight:'24px'}}>
              {pageIndex + 1} of {pageOptions.length}
            </Typography>{" "}
          </span>
          <IconButton onClick={() => previousPage()} disabled={!canPreviousPage}>
          <ChevronLeftIcon/>
          </IconButton>
          <IconButton onClick={() => nextPage()} disabled={!canNextPage}>
          <ChevronRightIcon/>
          </IconButton>
        </div>
      </TableContainer> : <></>}
    </div>
  );
}